import React, { createContext, useContext, useEffect, useState } from "react";
import { api, clearSession, getStoredUser, setSession } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getStoredUser());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // refresh user on mount if we have a token
    if (localStorage.getItem("argus.token") && !user) {
      api
        .get("/auth/me")
        .then((r) => {
          setUser(r.data);
          setSession(null, r.data);
        })
        .catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      setSession(r.data.token, r.data.user);
      setUser(r.data.user);
      return r.data.user;
    } finally {
      setLoading(false);
    }
  };

  const signup = async (payload) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/signup", payload);
      setSession(r.data.token, r.data.user);
      setUser(r.data.user);
      return r.data.user;
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      // Server logout is best-effort — we always clear the client session.
      console.warn("auth: server logout failed (clearing client session anyway)", err);
    }
    clearSession();
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, signup, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
